module.exports = __webpack_public_path__ + "img/bg-venueOverview.cc883938.jpg";